
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCwb1bvniBMwYhbomOa3Ce8oLZ0V9Q5tVo",
  authDomain: "gamepulse-hq.firebaseapp.com",
  projectId: "gamepulse-hq",
  storageBucket: "gamepulse-hq.firebasestorage.app",
  messagingSenderId: "989209654378",
  appId: "1:989209654378:web:59647a30acdd3e05e7c613",
  measurementId: "G-LCB6JJTMDL"
};

// Initialisation
const app = initializeApp(firebaseConfig);

// On exporte la base de données (db) et l'authentification (auth)
export const db = getFirestore(app);
export const auth = getAuth(app);